import { useTranslation } from 'react-i18next';
import { SidebarMenuItem } from './sidebar-menu-item';
import { SidebarMenuSectionProps } from './types';

export function SidebarMenuSection({
  section,
  currentPath,
  isCollapsed,
  openSubMenus,
  onNavigate,
  onToggleSubMenu,
}: SidebarMenuSectionProps) {
  const { t } = useTranslation('layout');
  return (
    <div className="px-3 py-2">
      {!isCollapsed && (
        <h3 className="px-3 mb-2 text-xs font-semibold uppercase tracking-wider text-blue-200">
          {t(section.title)}
        </h3>
      )}
      {section.items.map((item, itemIndex) => {
        const isActive = currentPath === item.path;
        const isSubMenuOpen = openSubMenus.includes(item.title);
        // Check if any submenu item is active
        const hasActiveSubmenu =
          item.submenu?.some((subItem) => currentPath === subItem.path) || false;
        return (
          <SidebarMenuItem
            key={itemIndex}
            item={item}
            isActive={isActive || hasActiveSubmenu}
            isCollapsed={isCollapsed}
            currentPath={currentPath}
            onNavigate={onNavigate}
            onToggleSubMenu={onToggleSubMenu}
            isSubMenuOpen={isSubMenuOpen}
          />
        );
      })}
    </div>
  );
}
